import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  Slide,
  Stack,
  Box,
  CircularProgress,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Autocomplete,
  TextField,
} from '@material-ui/core'
import { useSnackbar } from 'notistack'
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import { forwardRef, useState } from 'react'
import { MRadio } from './@material-extend'
import { useNavigate } from 'react-router'
import { PATH_DASHBOARD } from 'src/routes/paths'
import AddToStockPopup from './AddToStockPopup'

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const getChunks = (str) => {
    const chunks = [];
    let currentChunk = '';
    let chunkType = null; // 'hash', 'otherSpecial', 'digit', or 'letter'

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      const isDigit = /\d/.test(char);
      const isLetter = /[a-zA-Z]/.test(char);
      const isHash = char === '#';
      const isOtherSpecial = !isDigit && !isLetter && !isHash;
      
      // Determine chunk type with priority: hash < otherSpecial < digit < letter
      let currentType;
      if (isHash) {
        currentType = 'hash';
      } else if (isOtherSpecial) {
        currentType = 'otherSpecial';
      } else if (isDigit) {
        currentType = 'digit';
      } else {
        currentType = 'letter';
      }

      if (i === 0) {
        chunkType = currentType;
        currentChunk = char;
      } else if (currentType === chunkType) {
        currentChunk += char;
      } else {
        chunks.push({
          value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
          type: chunkType
        });
        currentChunk = char;
        chunkType = currentType;
      }
    }

    if (currentChunk) {
      chunks.push({
        value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
        type: chunkType
      });
    }

    return chunks;
  };

  const chunksA = getChunks(a);
  const chunksB = getChunks(b);
  const len = Math.min(chunksA.length, chunksB.length);

  // Type priority: hash (0) < otherSpecial (1) < digit (2) < letter (3)
  const getTypePriority = (type) => {
    if (type === 'hash') return 0;
    if (type === 'otherSpecial') return 1;
    if (type === 'digit') return 2;
    return 3; // letter
  };

  for (let i = 0; i < len; i++) {
    const chunkA = chunksA[i];
    const chunkB = chunksB[i];

    const priorityA = getTypePriority(chunkA.type);
    const priorityB = getTypePriority(chunkB.type);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // Same type, compare values
    if (chunkA.type === 'digit') {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    } else {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    }
  }

  if (chunksA.length < chunksB.length) return -1;
  if (chunksA.length > chunksB.length) return 1;

  return 0;
}

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function ConfirmationPopup({
  open,
  handleClose,
  message,
  handleClick,
  loading2,
  isComplete,
  setCompleteStatus,
  noServiceNoTask,
  shippingReturn,
  templates,
  isPickup,
  selectTemplate,
  setSelectTemplate,
  selectedInstallationIds,
  handleMarkAsPickup,
  popupOn,
  hideCancel,
  projectCategory,
  projectId,
  projectTasks,
  futureInstallations,
  existingJobCostData,
  includeChooseInstallation,
  selectedInstallation,
  setSelectedInstallation
}) {
  console.log('projectCategory', projectCategory)
  const { enqueueSnackbar } = useSnackbar()
  const theme = useTheme()
  const navigate = useNavigate()
  const [value, setValue] = useState('1');
  const [showAddToStockPopup, setShowAddToStockPopup] = useState(false);

  // Check if there are eligible products for adding to stock
  const hasEligibleProducts = () => {
    if (!projectTasks || projectTasks.length === 0) return false;
    
    // Filter products that have product_id not null, inhouse != 1, isTrafficCatalog = 0
    const eligibleProducts = projectTasks.filter(task => 
      task.product_id && 
      ((task.inhouse === 1 && task.isTrafficCatalog === 1) || task.inhouse !== 1)
      // task.inhouse !== 1 && 
      // task.isTrafficCatalog === 0
    );
    
    return eligibleProducts.length > 0;
  };
  
    const handleChange = (event) => {
      setValue(event.target.value);
      console.log('ghghfghfghfghfg',event.target.value);
      setCompleteStatus(event.target.value)
    };

    const handleAddToStockConfirm = (stockData) => {
      console.log('Add to stock data:', stockData);
      // Handle the add to stock logic here
      // You can call the parent's handleClick or create a new handler
      if (handleClick) {
        handleClick(stockData);
      }
    };

  return (
    <>
     {!isComplete ? (
      <Dialog
        aria-describedby="alert-dialog-slide-description"
        TransitionComponent={Transition}
        transitionDuration={500}
        sx={{ minWidth: {xs:0 , sm: 600} }}
        open={open}
        onClose={handleClose}
        onBackdropClick={handleClose}
        // onClick={(e) => e.stopPropagation()}
      >
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent sx={{ minWidth: 270, mt: -2 }}>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
          {
            includeChooseInstallation ? (
              <DialogContentText id="alert-dialog-description">
                <Autocomplete
                  fullWidth
                  options={futureInstallations}
                  getOptionLabel={(option) => option.name}
                  disabled={existingJobCostData && existingJobCostData?.for_product !== null && existingJobCostData?.for_service !== null}
                  value={selectedInstallation}
                  onChange={(event, newValue) => {
                    setSelectedInstallation(newValue)
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Product/Service"
                      placeholder="Select Product/Service"
                      size="small"
                    />
                  )}
                />
              </DialogContentText>
            ) : (
              ""
            )
          }
        {
          isPickup?
        
          <DialogContentText id="alert-dialog-description">
            <Autocomplete
                         fullWidth
                         options={(templates || []).sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))}
                         filterSelectedOptions
                         value={selectTemplate}
                         onChange={(event, newValue) => {  
                          setSelectTemplate(newValue)
                         }}
                         getOptionLabel={(option) => option.name}
                         renderInput={(params) => (
                           <TextField
                             {...params}
                             label="Select Template"
                             placeholder="Select Template"
                             size="small"
                           />
                         )}
                       />
          </DialogContentText>
          :""
                        }
        </DialogContent>
        {/* <DialogActions sx={{ justifyContent: 'flex-end !important' }}> */}
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          px={3}
          mb={2.5}
          mt={-1}
        >
          <Button
            size="medium"
            onClick={() => {
              handleClose()
              enqueueSnackbar('Operation was cancelled', { variant: 'error' })
            }}
            sx={{
              background: '#BB2525',
              boxShadow: `0 8px 16px 0 ${alpha('#BB2525', 0.24)}`,
              '&:hover': {
                background: '#FF8F8F',
                boxShadow: `0 8px 16px 0 ${alpha('#FF8F8F', 0.24)}`,
              },
            }}
          >
            <Typography
              sx={{ color: theme.palette.common.white }}
              variant="overline"
            >
              Cancel
            </Typography>
          </Button>
          <Button
            size="medium"
            variant="contained"
            onClick={() => {
              if(isPickup && !selectTemplate){
                return enqueueSnackbar('Select a Template', { variant: 'error' })
              }else if(isPickup && selectTemplate){
                if(popupOn){
                  handleMarkAsPickup(selectTemplate.id,selectedInstallationIds,isPickup)
                }else{
                navigate(`${PATH_DASHBOARD.installation.templateview}/${selectTemplate.id}`,{
                  state: { selectedInstallationIds: selectedInstallationIds,template_id : selectTemplate.i,isPickup:true}
                }, )
                }
              }else{
                handleClick()
              }
            }}
            sx={{ color: theme.palette.primary.main }}
            disabled={loading2}
          >
            {loading2 ? (
            <CircularProgress size={22} sx={{ color: theme.palette.common.white }} />
          ) : (
            <Typography
              sx={{ color: theme.palette.common.white }}
              variant="overline"
            >
              Yes
            </Typography>
          )}
          </Button>
        </Stack>
        {/* </DialogActions> */}
      </Dialog>
      ):(
        <Dialog
        aria-describedby="alert-dialog-slide-description"
        TransitionComponent={Transition}
        transitionDuration={500}
        sx={{ minWidth: {xs:0 , sm: 600},padding:'5px' }}
        open={open}
        // onClose={handleClose}
        // onBackdropClick={handleClose}
        // onClick={(e) => e.stopPropagation()}
      >
        {/* <DialogTitle>{projectCategory == 12 ? "Send For Review" :noServiceNoTask == 1 ? 'No Installations - Proceed to Invoicing' : 'Please Choose from the following'}</DialogTitle> */}
        <DialogTitle>
          {(noServiceNoTask == 1 && projectCategory !== 12 )
            ? 'No Installations - Proceed to Invoicing'
            : 'Please Choose from the following'}
        </DialogTitle>
        <DialogContent sx={{ minWidth: 270, mt: 0 }}>
          <DialogContentText id="alert-dialog-description">
            {/* {message} */}
            <FormControl component="fieldset">
              <RadioGroup value={value} onChange={handleChange}>
                {/* Service Only jobs (project_category 11): only "Installs" */}
                {projectCategory == 11 ? (
                  <FormControlLabel value="1" control={<Radio />} label="Installs" />
                ) : (noServiceNoTask == 1 && projectCategory !== 12) ? (
                  // No installations and not T&M: only "Invoice"
                  <FormControlLabel value="1" control={<Radio />} label="Invoice" />
                ) : (
                  // Default: full list
                  <>
                    <FormControlLabel value="1" control={<Radio />} label="Installs" />
                    <FormControlLabel value="2" control={<Radio />} label="Pickup" />
                    <FormControlLabel value="3" control={<Radio />} label="Shipping" />
                    {projectCategory == 13 ? (
                      <FormControlLabel value="4" control={<Radio />} label="Add to stock" />
                    ) : (
                      ''
                    )}
                  </>
                )}
              </RadioGroup>
            </FormControl>
          </DialogContentText>
        </DialogContent>
        {/* <DialogActions sx={{ justifyContent: 'flex-end !important' }}> */}
        <Stack
          direction={'row'}
          justifyContent={'flex-end'}
          px={3}
          mb={2.5}
          mt={-1}
        >
          {
            hideCancel ? "" :
         
          <Button
            size="medium"
            onClick={() => {
              handleClose()
              enqueueSnackbar('Operation was cancelled', { variant: 'error' })
            }}
            sx={{
              background: '#BB2525',
              boxShadow: `0 8px 16px 0 ${alpha('#BB2525', 0.24)}`,
              '&:hover': {
                background: '#FF8F8F',
                boxShadow: `0 8px 16px 0 ${alpha('#FF8F8F', 0.24)}`,
              },
            }}
          >
            <Typography
              sx={{ color: theme.palette.common.white }}
              variant="overline"
            >
              Cancel
            </Typography>
          </Button>
           }

          <Button
            size="medium"
            variant="contained"
            onClick={() => {
              if (value === '4') {
                // Check if there are eligible products before showing the popup
                if (!hasEligibleProducts()) {
                  enqueueSnackbar("Production catalog doesn't have stock", { variant: 'warning' });
                  return;
                }
                // Show Add to Stock popup
                setShowAddToStockPopup(true);
              } else {
                handleClick()
              }
            }}
            // sx={{ color: theme.palette.primary.main }}
            disabled={loading2}
          >
            <Typography
              sx={{ color: theme.palette.common.white }}
              variant="overline"
            >
            </Typography>
              {loading2 ? <CircularProgress size={24} color="inherit" /> : 'Yes'}
          </Button>
        </Stack>
        {/* </DialogActions> */}
      </Dialog>)}

      {/* Add to Stock Popup */}
      <AddToStockPopup
        open={showAddToStockPopup}
        handleClose={() => setShowAddToStockPopup(false)}
        projectId={projectId}
        onConfirm={handleAddToStockConfirm}
      />
    </>
  )
}
